import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Heart, Search, Menu, X } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";

export default function Navbar() {
  const loc = useLocation();
  const { count, setOpen } = useWishlist();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const isAdmin = loc.pathname.startsWith("/admin");
  if (isAdmin) return null;

  const links = [
    { to: "/", label: "Home" },
    { to: "/catalogue", label: "Catalogue" },
    { to: "/ringstudio", label: "Ringstudio" },
    { to: "/solitaires", label: "Solitaires" },
    { to: "/ai-tools", label: "AI Tools" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header
      className="sticky top-0 z-40 border-b border-gold/20"
      style={{ background: "#050B1F", color: "#FFFFFF" }}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-4 flex items-center gap-6">
        <Link to="/" className="flex items-center gap-3 flex-shrink-0" data-testid="nav-logo">
          <img src="https://customer-assets.emergentagent.com/job_gem-catalogue/artifacts/nrqp6drv_Untitled%20design-9.png" alt="Bholaa Jewels" className="h-9 w-9 lg:h-11 lg:w-11 object-contain" />
          <div className="leading-tight">
            <div className="font-brand text-lg lg:text-2xl whitespace-nowrap" style={{ fontWeight: 700, letterSpacing: '0.04em', color: '#FFFFFF' }}>BHOLAA JEWELS</div>
            <div className="text-[10px] lg:text-[11px] tracking-[0.22em] uppercase mt-0.5" style={{ color: '#D9BE6E' }}>Est. 1966 · Chandigarh</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7 ml-auto">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="text-[12px] tracking-[0.2em] uppercase font-medium transition-colors whitespace-nowrap hover:text-[#D9BE6E]"
              style={{ color: "#FFFFFF" }}
              data-testid={`nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3 ml-auto lg:ml-0 flex-shrink-0">
          <Link to="/catalogue" className="hidden lg:inline-flex items-center gap-2 transition-colors hover:text-[#D9BE6E]" style={{ color: "#FFFFFF" }} data-testid="nav-search">
            <Search className="w-4 h-4" />
          </Link>
          <button onClick={() => setOpen(true)} className="relative flex items-center gap-2 px-3 py-2 border transition-colors" style={{ borderColor: "rgba(217,190,110,0.5)", color: "#FFFFFF" }} data-testid="nav-wishlist-button">
            <Heart className="w-4 h-4" style={{ color: "#D9BE6E" }} />
            <span className="text-[11px] tracking-widest uppercase hidden sm:inline" style={{ color: "#FFFFFF" }}>Wishlist</span>
            <span className="font-medium text-sm" style={{ color: "#D9BE6E" }}>({count})</span>
          </button>
          <Link to="/admin" className="hidden lg:inline-flex text-[10px] tracking-[0.25em] uppercase transition-colors hover:text-[#D9BE6E]" style={{ color: "#FFFFFF" }} data-testid="nav-admin-link">Admin</Link>
          <button className="lg:hidden" style={{ color: "#FFFFFF" }} onClick={() => setMobileOpen((v) => !v)} data-testid="nav-mobile-toggle">
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {mobileOpen && (
        <div className="lg:hidden border-t px-6 py-4 space-y-3" style={{ borderColor: "rgba(217,190,110,0.15)", background: "#050B1F" }}>
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setMobileOpen(false)} className="block tracking-widest text-sm uppercase hover:text-[#D9BE6E]" style={{ color: "#FFFFFF" }} data-testid={`mobile-nav-${l.label.toLowerCase()}`}>{l.label}</Link>
          ))}
          <Link to="/admin" onClick={() => setMobileOpen(false)} className="block tracking-widest text-sm uppercase hover:text-[#D9BE6E]" style={{ color: "rgba(255,255,255,0.7)" }}>Admin</Link>
        </div>
      )}
    </header>
  );
}
